const inStockAndInStockOnlyWarehouseTypes = [
	'StockLevel',
	'InStockMessagingWithWarehouseOnly',
];

const getInventoryMessage = (message) => {
	const displayStockLevel = inStockAndInStockOnlyWarehouseTypes.includes(message.inventoryMessageType);
	let inventoryMessage = (displayStockLevel ? message.inventoryMessage.inventory_message : message.inventoryMessage) || '';
	if (message.inventoryMessageType === 'OutOfStockMessagingOnly') {
		inventoryMessage = `<i class="fa fa-exclamation-triangle"></i> ${inventoryMessage}`;
	}

	return inventoryMessage;
};

const getShippingMessage = (message) => {
	const displayStockLevel = inStockAndInStockOnlyWarehouseTypes.includes(message.inventoryMessageType);
	return (displayStockLevel ? message.inventoryMessage.shipping_message : null) || '';
};

const getPickupMessage = (message) => {
	const displayStockLevel = inStockAndInStockOnlyWarehouseTypes.includes(message.inventoryMessageType);
	return (displayStockLevel ? message.inventoryMessage.pickup_message : null) || '';
};

module.exports = {
	getInventoryMessage,
	getShippingMessage,
	getPickupMessage,
};